// extracted by mini-css-extract-plugin
export var container = "Banner-module--container--21824";
export var content = "Banner-module--content--9be03";
export var icon = "Banner-module--icon--aae39";
export var set = "Banner-module--set--a54ed";
export var sets = "Banner-module--sets--084cd";
export var setsContainer = "Banner-module--setsContainer--0a9cd";
export var title = "Banner-module--title--30610";